import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Martini: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M8 22h8' }],
    ['path', { d: 'M12 11v11' }],
    ['path', { d: 'm19 3-7 8-7-8Z' }],
  ],
];

export default Martini;
